import React, { Component } from "react";
import { Route, useLocation, Link } from "react-router-dom";
export default class HeaderMenuList extends Component {
 
    constructor() {
        super();
        this.state = {
            isLoading: true,
        }
      }
    render() {
        if (localStorage.getItem('user-info')) {
            let user = JSON.parse(localStorage.getItem('user-info'))
              return (
                <>
                     <a href="/favoritetagspage"> أخباري </a>
                </>);
        } else {
            return '';
        }
    }
}
